/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamReportMediaRequest } from './oralExamReportMediaRequest';

export type ReportOralExamMediaEnabledBody = OralExamReportMediaRequest | null;
